export default class StockSearchItemBase {
    constructor() {

        this.skuNumber = '';
        this.skuName = '';
        this.skuGroup = '';
        this.skuDescription = '';
        this.warehouse = '';
        this.descHeadOne = '';
        this.descHeadTwo = '';
        this.descHeadThree = '';
        this.descHeadFour = '';
        this.descHeadFive = '';
        this.descHeadSix = '';
    }
}
